<template>
  <div class="section_11">
    <div class="box_12 flex-row justify-between">
      <span class="text_29">店铺入驻&nbsp;权益加磅</span>
    </div>
    <div class="text-wrapper_9 flex-row">
          <span class="paragraph_3"
          >超快速0元开店、超省心1V1指导<br />0元入驻-0保证金-0服务费（仅限首次首年入驻）</span
          >
    </div>
    <div class="text-wrapper_10 flex-row">
      <span class="text_30">入驻流程：</span>
    </div>
    <div class="box_13 flex-row">
      <div class="box_14 flex-row justify-between">
        <div class="">
          <img style="  height: 254px; width: 400px;"
               class="image_12"
               referrerpolicy="no-referrer"
               src="../assets/shangjiaruzhu/sjrz1.png"/>
        </div>
        <div class="">
          <img style="  height: 254px; width: 400px;"
               class="image_12"
               referrerpolicy="no-referrer"
               src="../assets/shangjiaruzhu/sjrz2.png"/>
        </div>
        <div class="">
          <img style="  height: 254px; width: 400px;"
               class="image_12"
               referrerpolicy="no-referrer"
               src="../assets/shangjiaruzhu/sjrz3.png"/>
        </div>
      </div>
    </div>
    <div class="box_16 flex-row">
      <span class="text_37">扫码进入商家入驻</span>
    </div>
    <div class="container_phone">
      <img
          class="content_img"
          src="../../public/shangjiaruzhu.webp"
          referrerpolicy="no-referrer"
      />
    </div>
    <div class="box_9 flex-col"></div>
  </div>
  </template>
  
  <script>

  export default {
    name: 'MembersList',
    data() {
      return {
        members: [],
        loadComplete: false,
        startX: null,
        startY: null,
      };
    },
    methods: {
      // 新增触摸事件处理
      handleTouchStart(e) {
        this.startY = e.touches[0].clientY;
      },
      handleTouchEnd(e) {
        if (!this.startY) return;
        const endY = e.changedTouches[0].clientY;
        const deltaY = endY - this.startY;
        const deltaX = Math.abs(e.changedTouches[0].clientX - this.startX);
        console.log('1',deltaY,deltaX,Math.abs(deltaY))

        // 垂直滑动距离大于30px且水平滑动小于50px时才触发
        if (Math.abs(deltaY) > 50 && deltaX < 400) {
          if (deltaY > 0) { // 向下滑动
            this.$router.push('/committee-list.html'); // 跳转

          } else if (deltaY < 0) { // 向上滑动
            this.$router.push('/hezuopinpai.html');
          }
        }
        this.startY = null;
      },
      handleWheelScroll(e) {
        if (e.ctrlKey || e.metaKey) return; // 过滤组合键操作

        if (e.deltaY > 0) { // 检测向下滚动
          this.$router.push('/hezuopinpai.html');
        }else if (e.deltaY < 0) { // 检测向上滚动
          this.$router.push('/committee-list.html'); // 跳转
        }
      },
      handleKeyDown(e) {
        // 阻止Ctrl+加号/减号/鼠标滚轮
        if ((e.ctrlKey === true || e.metaKey) &&
            (e.keyCode === 61 || e.keyCode === 107 ||
                e.keyCode === 173 || e.keyCode === 109 ||
                e.keyCode === 187  || e.keyCode === 189)) {
          e.preventDefault();
        }
      },
      handleWheel(e) {
        if (e.ctrlKey || e.metaKey) {
          e.preventDefault();
        }
      },
      handleTouchMove(e) {
        if (e.scale !== 1) {
          e.preventDefault();
        }
      },
    },
    mounted() {
      // 添加触摸事件监听
      document.addEventListener('touchstart', this.handleTouchStart, { passive: false });
      document.addEventListener('touchend', this.handleTouchEnd, { passive: false });
      window.addEventListener('wheel', this.handleWheelScroll);
      // 禁用快捷键缩放
      document.addEventListener('keydown', this.handleKeyDown);
      // 禁用双指缩放（移动端）
      document.addEventListener('wheel', this.handleWheel, { passive: false });
      // 禁用触摸事件缩放
      document.addEventListener('touchmove', this.handleTouchMove, { passive: false });
    },
    beforeUnmount() {
      // 移除触摸事件监听
      document.removeEventListener('touchstart', this.handleTouchStart);
      document.removeEventListener('touchend', this.handleTouchEnd);
      // 移除滚轮事件监听
      window.removeEventListener('wheel', this.handleWheelScroll);
      document.removeEventListener('keydown', this.handleKeyDown);
      document.removeEventListener('wheel', this.handleWheel);
      document.removeEventListener('touchmove', this.handleTouchMove);
    },
    computed: {
      containerStyle() {
        return {
          transform: `scale(${this.scale})`,
          transformOrigin: 'top left',
          width: `${100 / this.scale}%`,
          height: `${100 / this.scale}%`
        };
      }
    },
  };
  </script>
  
<style>
@media (max-width: 768px) {
  .section_11 {
    z-index: 0 !important;
  }
  .container_phone {
    position: absolute;
    left: 50% !important;
    top: 5px !important;
    width: 336px;
    height: 663px;
    transform: translateX(-50%) scale(0.8) !important;  /* 水平居中 */
  }
  .box_9 {
    border-radius: 50%;
    background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/3470795bab204b02b1fc179b17455679_mergeImage.png);
    position: absolute;
    left: 75% !important;
    top: 553px !important;
    width: 131px;
    height: 131px;
    border: 1.55px solid;
    z-index: 1;
    transform: translateX(-50%) scale(0.8) !important;
  }
  .text_37 {
    left: 75% !important;
    top: 673px !important;
    transform: translateX(-50%) !important;
  }
}
.section_11 {
  background-image: url(../assets/shangjiaruzhu/beijingtu.webp);
  width: 100vw;
  height: 100vh;
  /* 绝对定位覆盖全屏 */
  position: fixed;
  top: 0;
  left: 0%;
  /* 背景图等比例填充 */
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
  z-index: -1;
}

.box_12 {
  position: relative;
  width: 869px;
  height: 116px;
  margin: 116px 0 0 81px;
}


.text_29 {
  position: absolute;
  left: 434px;
  top: 51px;
  width: 402px;
  height: 65px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 46px;
  letter-spacing: 1.5499999523162842px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 65px;
}

.text-wrapper_9 {
  width: 735px;
  height: 72px;
  margin: 11px 0 0 515px;
}

.paragraph_3 {
  width: 735px;
  height: 72px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 25px;
  letter-spacing: 7.12999963760376px;
  font-family: PingFangSC-Light;
  font-weight: 300;
  text-align: left;
  line-height: 36px;
}

.text-wrapper_10 {
  width: 101px;
  height: 28px;
  margin: 54px 0 0 515px;
}

.text_30 {
  width: 101px;
  height: 28px;
  overflow-wrap: break-word;
  color: rgba(254, 242, 240, 1);
  font-size: 20px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 28px;
}

.box_13 {
  width: 1272px;
  height: 284px;
  margin: 19px 0 0 515px;
}

.box_14 {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap; /* 新增防止换行 */
  justify-content: space-between;
  width: 100%; /* 改为百分比适应父容器 */
}


.block_10 .paragraph_6 {
  display: block; /* 新增：强制换行 */
  width: 173px;
  margin-top: 8px; /* 添加段落间距 */
  margin-left: 23px; /* 调整左外边距 */
}

.image_12 {
  width: 23px;
  height: 13px;
}

.box_16 {
  width: 1358px;
  height: 120px;
  margin: 90px 0 27px 46px;
}


.text_37 {
  width: 137px;
  height: 24px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 17px;
  font-family: PingFangSC-Light;
  font-weight: 300;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
  position: fixed;
  left: 361px;
  top: 863px;
}

.image_13 {
  width: 92px;
  height: 102px;
  margin-left: 820px;
}
.container_phone {
  position: absolute;
  left: 111px;
  top: 113px;
  width: 336px;
  height: 663px;
}
.content_img {
  position: absolute;
  width: 90%; /* 根据边框尺寸调整 */
  height: 94%;
  left: 5%;
  top: 12%;
  object-fit: cover;
  border-radius: 55px; /* 根据实际边框弧度调整 */
}
.box_9 {
  border-radius: 50%;
  background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/3470795bab204b02b1fc179b17455679_mergeImage.png);
  position: absolute;
  left: 358px;
  top: 723px;
  width: 131px;
  height: 131px;
  border: 1.55px solid;
  z-index: 1;
}
</style>